import "./LoadingSpinner.css";

const LoadingSpinner = () => <div className="verdenskart-loading-spinner" />;

export default LoadingSpinner;
